<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月18日 15:46:35 +0800
 * @最后修改时间: 2022-03-09 13:23:39
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimRecord\ClaimRecordItem.vue
-->

<template>
  <ContentLayout title="Claim Record Item Viewer" widthClass="max-1000">
    <!-- content -->
    <template v-slot:page-main>
      <v-card class="pa-3 ma-2 elevation-0">
        <v-form ref="form1" lazy-validation>
          <v-row>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <v-text-field
                readonly
                v-model="ClaimRecordItemData.claim_type_name"
                label="Claim Type:"
              ></v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <v-text-field
                readonly
                v-model="ClaimRecordItemData.claim_item_name"
                label="Item Name:"
              ></v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <v-text-field
                readonly
                v-model="ClaimRecordItemData.pay_utc_datetime"
                label="Consumption Date:"
              ></v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <v-text-field
                readonly
                v-model="ClaimRecordItemData.claim_reason_text"
                label="Reason:"
              ></v-text-field>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <v-text-field
                readonly
                v-model="ClaimRecordItemData.claim_item_description"
                label="Description:"
              ></v-text-field>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <v-text-field
                readonly
                v-model="ClaimRecordItemData.remarks"
                label="Remarks:"
              ></v-text-field>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              AttachMent:
              <div
                class="
                  max-width
                  border-solid-grey-1 border-radius-5
                  d-flex
                  justify-start
                "
              >
                <v-img
                  v-for="(
                    img, index
                  ) in ClaimRecordItemData.receipt_invoice_url"
                  :key="index"
                  :src="img"
                  max-height="120"
                  max-width="120"
                  style="width:100px:height:100px"
                  class="ma-2"
                ></v-img>
              </div>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <v-text-field
                readonly
                v-model="ClaimRecordItemData.receipt_swift_number"
                label="Ref.ID:"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <!-- form -->
      <v-card class="ma-2 pa-3 elevation-0">
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <v-text-field
                readonly
                v-model="ClaimRecordItemData.actual_amount"
                label="Actual Amount:"
                :suffix="ClaimRecordItemData.actual_currency_symbol"
              ></v-text-field>
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <v-text-field
                v-model="ClaimRecordItemData.claim_amount"
                :suffix="ClaimRecordItemData.claim_currency_symbol"
                readonly
                label="Claim Amount:"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </template>
    <!-- content -->
  </ContentLayout>
</template>
<script>
export default {
  name: "editClaimRecord",
  computed: {},
  data() {
    return {
      ClaimRecordItemData: {
        uuid: "",
        claim_form_master_uuid: "",
        claim_type_uuid: "",
        claim_type_name: "",
        claim_reason_uuid: "",
        claim_reason_name: "",
        claim_reason_text: "",
        claim_item_name: "",
        claim_form_description: "",
        remarks: "",
        receipt_swift_number: "",
        receipt_invoice_url: [],
        pay_utc_datetime: "",
        pay_date_time_zone: "",
        entry_utc_datetime: "",
        entry_date_time_zone: "",
        approval_status: "",
        actual_amount: "",
        actual_currency_uuid: "",
        actual_currency_name: "",
        actual_currency_symbol: "",
        approved_amount: "",
        approved_currency_uuid: "",
        approved_currency_name: "",
        approved_currency_symbol: "",
        claim_amount: "",
        claim_currency_uuid: "",
        claim_currency_name: "",
        claim_currency_symbol: "",
        approval_status: "",
        ess_claim_form_record_item_custom_field: [],
      },
    };
  },
  watch: {},
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_form_record_items",
        url: "/claim-record-items/get-claim-record-items-details/",
        data: { uuid: this.$route.query.id },
      }).then((res) => {
        res.data.receipt_invoice_url = res.data.receipt_invoice_url
          ? res.data.receipt_invoice_url.split(",")
          : [];
        that.ClaimRecordItemData = res.data;
      });
    },
  },
};
</script>
